import {fwUrlUtils} from "assecobs-faktor-web-common/index";

export default {
    LOGIN: fwUrlUtils.getApiUrl("/login")
}
